// src/dashboard/pages/teacher/ToDoList/components/TaskEmptyState.jsx

import React from "react";
import { FaPlus } from "react-icons/fa";

export default function TaskEmptyState({ onAdd }) {
  return (
    <div className="mt-5 rounded-[24px] border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto h-16 w-16 rounded-full bg-gradient-to-br from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <h3 className="mt-6 text-lg font-bold text-slate-900 dark:text-white">
        Aucune tâche trouvée
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
        Ajoutez une tâche ou modifiez vos filtres de recherche.
      </p>

      <button
        type="button"
        onClick={onAdd}
        className="mt-5 inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6c]"
      >
        <FaPlus />
        Ajouter une tâche
      </button>
    </div>
  );
}